import { TSmartODataTableStorage } from "@components/smart/smartTable/SmartODataTableBase";
import React, { ReactElement } from "react";

import { DomManipulatorProvider } from "../contexts/domManipulator/DomManipulatorProvider";
import { ITableViewBaseProps } from "../views/table/TableView";
import { IDefinition } from "./PageUtils";
import { ISplitPageProps, SplitPageBase, TRenderTableArgs } from "./SplitPageBase";

export interface IProps extends Omit<ISplitPageProps, "renderTable"> {
    getDefinitions?: (storage?: TSmartODataTableStorage) => IDefinition;
    onTableStorageLoad?: (storage: TSmartODataTableStorage) => Promise<void>;
    tableView: React.ComponentType<ITableViewBaseProps>;
}

class SplitPage extends React.Component<IProps> {
    renderTable = (args: TRenderTableArgs): ReactElement => {
        const Table = this.props.tableView;

        return (
            <DomManipulatorProvider>
                <Table {...args} {...this.props.tableViewProps}/>
            </DomManipulatorProvider>
        );
    };

    render() {
        return (
            <SplitPageBase {...this.props} renderTable={this.renderTable}/>
        );
    }
}

export { SplitPage };